export const CARD_CONFIGS = {
  TOTAL_PEOPLE: {
    icon: 'PeopleAltOutlined',
    color: 'primary',
    tooltipTitle: 'conversion-report.link.total-person',
    subText: 'conversion-report.link.total-personTooltip'
  },
  GENERATED_LINKS: {
    icon: 'Link',
    color: 'primary',
    tooltipTitle: 'conversion-report.link.generated-link',
    subText: 'conversion-report.link.generated-linkTooltip'
  },
  OPENING: {
    icon: 'Visibility',
    color: 'primary',
    tooltipTitle: 'conversion-report.link.opening',
    subText: 'conversion-report.link.openingTooltip'
  },
  ANSWERED: {
    icon: 'PlaylistAddCheck',
    color: 'primary',
    tooltipTitle: 'conversion-report.link.answered',
    subText: 'conversion-report.link.answeredTooltip'
  }
}

export const DEFAULT_VALUES = {
  TotalIdentified: 0,
  TotalAnonymousNotAnswered: 0,
  TotalDirectLinkGenerated: 0,
  Opened: 0,
  Answered: 0
}

export const formatNumber = (num, decimals = 1) => {
  if (num === null || num === undefined) return '0,0'
  return num.toFixed(decimals).replace('.', ',')
}

export const calculateTotalPeople = (linkData) => {
  return (
    (linkData?.TotalIdentified || 0) +
    (linkData?.TotalAnonymousNotAnswered || 0)
  )
}

export const calculateViewsPerPerson = (opened, totalPeople) => {
  if (!totalPeople || totalPeople === 0) return 0
  return opened / totalPeople
}

export const calculatePercentage = (value, total, decimals = 1) => {
  if (!total || total === 0) return 0
  return (value / total) * 100
}

export const formatPercentage = (value, total, decimals = 1) => {
  const percentage = calculatePercentage(value, total, decimals)
  return `${formatNumber(percentage, decimals)}%`
}

export const getConversionMetrics = (linkData) => {
  const totalPeople = calculateTotalPeople(linkData)
  const viewsPerPerson = calculateViewsPerPerson(
    linkData?.Opened || 0,
    totalPeople
  )
  const answeredPercentage = calculatePercentage(
    linkData?.Answered || 0,
    totalPeople
  )

  return {
    totalPeople,
    viewsPerPerson: formatNumber(viewsPerPerson),
    answeredPercentage: formatPercentage(linkData?.Answered || 0, totalPeople),
    raw: {
      totalPeople,
      viewsPerPerson,
      answeredPercentage: answeredPercentage
    }
  }
}
